/**
 * @module app.kya.contracts.cancelReplaceContractCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function CancelReplaceContractCtrl($scope, $uibModalInstance) {
        let self = {};

        self.cancel = function() {
            $uibModalInstance.close(true);
        };

        self.doNotCancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        return self;
    }

    CancelReplaceContractCtrl.$inject = ['$scope', '$uibModalInstance'];

    angular
        .module('app.kya.contracts.cancelReplaceContractCtrl', ['ui.bootstrap.modal', 'ui-notification'])
        .controller('CancelReplaceContractCtrl', CancelReplaceContractCtrl);
});
